// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faust-ui-group {
  position: absolute;
  display: block;
  background-color: rgba(80, 80, 80, 0.75);
  border-radius: 4px;
  border: 1px rgba(255, 255, 255, 0.25) solid;
}
.faust-ui-group > .faust-ui-group-label {
  position: relative;
  margin: 4px;
  width: calc(100% - 8px);
  user-select: none;
}
.faust-ui-group > .faust-ui-group-label > canvas {
  position: relative;
  display: block;
  max-width: 100%;
  max-height: 100%;
}
.faust-ui-group .faust-ui-tgroup-tabs {
  position: absolute;
  display: inline-block;
  white-space: nowrap;
  left: 0px;
}
.faust-ui-group .faust-ui-tgroup-tabs .faust-ui-tgroup-tab {
  position: relative;
  display: inline-block;
  border-radius: 5px;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: none;
  margin: 10px;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.5);
}
.faust-ui-group .faust-ui-tgroup-tabs .faust-ui-tgroup-tab:hover {
  background-color: rgb(255, 255, 255);
}
.faust-ui-group .faust-ui-tgroup-tabs .faust-ui-tgroup-tab.active {
  background-color: rgb(40, 40, 40);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/Group.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,cAAA;EACA,wCAAA;EACA,kBAAA;EACA,2CAAA;AAAJ;AACI;EACI,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;AACR;AAAQ;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAEZ;AACI;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,SAAA;AACR;AAAQ;EACI,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;AAEZ;AADY;EACI,oCAAA;AAGhB;AADY;EACI,iCAAA;EACA,YAAA;AAGhB","sourcesContent":["\n.faust-ui-group {\n    position: absolute;\n    display: block;\n    background-color: rgba(80, 80, 80, 0.75);\n    border-radius: 4px;\n    border: 1px rgba(255, 255, 255, 0.25) solid;\n    & > .faust-ui-group-label {\n        position: relative;\n        margin: 4px;\n        width: calc(100% - 8px);\n        user-select: none;\n        & > canvas {\n            position: relative;\n            display: block;\n            max-width: 100%;\n            max-height: 100%;\n        }\n    }\n    & .faust-ui-tgroup-tabs {\n        position: absolute;\n        display: inline-block;\n        white-space: nowrap;\n        left: 0px;\n        & .faust-ui-tgroup-tab {\n            position: relative;\n            display: inline-block;\n            border-radius: 5px;\n            cursor: pointer;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            user-select: none;\n            margin: 10px;\n            text-align: center;\n            background-color: rgba(255, 255, 255, 0.5);\n            &:hover {\n                background-color: rgba(255, 255, 255, 1);\n            }\n            &.active {\n                background-color: rgba(40, 40, 40, 1);\n                color: white;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
